<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0 mt-2"
  >
    <template #toggler>
      <CHeaderNavLink class="account-toggle">
        <div class="account-meta d-none d-md-flex">
          <div class="account-text">
            <div class="account-name">{{ displayName }}</div>
            <div class="account-role">{{ roleLabel }}</div>
          </div>
        </div>
        <div class="c-avatar account-avatar">
          <img :src="avatarSrc" class="c-avatar-img" alt="profile" />
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>{{ displayName }}</strong>
      <div class="small text-muted mt-1">{{ roleLabel }}</div>
    </CDropdownHeader>
    <CDropdownItem @click="openGeneralPage('/general/profile')">
      <CIcon name="cil-user" size="xl" /> {{ $t('shell.profile') }}
    </CDropdownItem>
    <CDropdownItem @click="openGeneralPage('/general/preferences')">
      <CIcon name="cil-settings" size="xl" /> {{ $t('shell.preferences') }}
    </CDropdownItem>
    <CDropdownItem @click="onLogout">
      <CIcon name="cil-lock-locked" size="xl" /> {{ $t('shell.signOut') }}
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { getAssignedRoles, getRoleLabel, getWorkspaceRole, workspaceRoleEventName } from '@/utils/role-dashboard'
import defaultAvatar from '@/assets/avatars/1.jpg'
import { showConfirmAlert } from '@/utils/sweet-alert'
import { shouldConfirmBeforeSignOut, shouldKeepNavigationContext } from '@/utils/workspace-preferences'

function pickText(value) {
  if (!value) return ''
  if (typeof value === 'string') return value.trim()
  if (Array.isArray(value)) {
    const found = value.find(item => item && item.value)
    return found && found.value ? String(found.value).trim() : ''
  }
  if (typeof value === 'object') {
    return String(value.value || value.name || value.label || '').trim()
  }
  return ''
}

export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      workspaceRoleVersion: 0
    }
  },
  computed: {
    profile() {
      return this.$store.getters['auth/profile'] || null
    },
    workspaceRole() {
      this.workspaceRoleVersion
      if (getAssignedRoles(this.$store).length > 1) {
        return 'multiuser'
      }
      return getWorkspaceRole(this.$store)
    },
    roleLabel() {
      return getRoleLabel(this.workspaceRole)
    },
    displayName() {
      const profile = this.profile
      if (!profile) return 'User'

      const userinfo = profile.userinfo || {}
      const prefix = pickText(userinfo.prefix)
      const firstName = pickText(userinfo.firstName) || pickText(profile.firstName)
      const lastName = pickText(userinfo.lastName) || pickText(profile.lastName)
      const fullName = [prefix, firstName, lastName].filter(Boolean).join(' ').trim()

      return fullName || profile.fullName || profile.name || profile.email || 'User'
    },
    avatarSrc() {
      const profile = this.profile
      const userinfo = profile && profile.userinfo ? profile.userinfo : {}
      return (userinfo.imageProfile && userinfo.imageProfile.src) ||
        userinfo.image ||
        defaultAvatar
    }
  },
  mounted() {
    window.addEventListener(workspaceRoleEventName(), this.handleWorkspaceRoleChange)
  },
  beforeDestroy() {
    window.removeEventListener(workspaceRoleEventName(), this.handleWorkspaceRoleChange)
  },
  methods: {
    handleWorkspaceRoleChange() {
      this.workspaceRoleVersion += 1
    },
    buildGeneralLocation(path) {
      if (!shouldKeepNavigationContext()) return path
      const workspace = this.$route && this.$route.query ? this.$route.query.workspace : ''
      return workspace ? { path, query: { workspace } } : path
    },
    async openGeneralPage(path) {
      await this.$router.push(this.buildGeneralLocation(path))
    },
    async onLogout() {
      if (shouldConfirmBeforeSignOut()) {
        const confirmed = await showConfirmAlert({
          title: 'Sign out?',
          text: 'You will need to sign in again to continue working.',
          confirmButtonText: 'Sign out'
        })
        if (!confirmed) return
      }
      this.$store.dispatch('auth/signOut')
    }
  }
}
</script>

<style scoped>
.account-toggle {
  align-items: center;
  display: flex;
  padding-right: 0;
}

.account-meta {
  align-items: center;
  margin-right: 0.75rem;
}

.account-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.1;
}

.account-name {
  color: #3c4043;
  font-weight: 600;
  white-space: nowrap;
}

.account-role {
  color: #8a8f98;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 0.2rem;
  white-space: nowrap;
}

.account-avatar {
  height: 42px;
  width: 42px;
}

.c-icon {
  margin-right: 0.3rem;
}

.c-header-nav .dropdown-item {
  min-width: 250px;
}
</style>
